import { useState } from 'react';
import * as Sentry from '@sentry/react';
import { fetchLogout } from 'store/actions/auth';
import { useAppDispatch } from 'store/store';
/** */
export const useLogout = (): { logout: () => void; isLogoutLoading: boolean } => {
    const [isLogoutLoading, setLogoutLoading] = useState(false);
    const dispatch = useAppDispatch();
    /** */
    const logout = () => {
        setLogoutLoading(true);
        dispatch(fetchLogout()).finally(() => {
            setLogoutLoading(false);
            Sentry.setUser(null);
            window?.$chatwoot?.reset();
            window.open(`${process.env.REACT_APP_SSO_CLIENT}/?return=${window.location.origin}`, '_self');
        });
    };

    return { logout, isLogoutLoading };
};
